module.exports = __webpack_public_path__ + "static/media/breach-reports.0e456b95.jpg";